import { Action, ActionFunctionAny, createAction } from 'redux-actions'
import { call, put } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { errorActions } from '@/modules/common/error'
import { loadingActions } from '@/modules/common/loading'

interface ActionGroup {
  TYPE: string
  FAILURE: string
  SUCCESS: string
  REQUEST: string
  request: ActionFunctionAny<Action<any>>
  success: ActionFunctionAny<Action<any>>
  failure: ActionFunctionAny<Action<any>>
}
interface IFetchActionGroup extends ActionGroup {
  FETCH: string
  fetch: ActionFunctionAny<Action<any>>
}

interface IPostActionGroup extends ActionGroup {
  POST: string
  post: ActionFunctionAny<Action<any>>
}

export function createFetchAction<T>(type: string): IFetchActionGroup {
  const FETCH = `${type}/FETCH`
  const SUCCESS = `${type}/SUCCESS`
  const FAILURE = `${type}/FAILURE`
  const REQUEST = `${type}/REQUEST`

  return {
    TYPE: type,
    FETCH,
    SUCCESS,
    FAILURE,
    REQUEST,
    fetch: createAction<T>(FETCH),
    request: createAction(REQUEST),
    success: createAction(SUCCESS),
    failure: createAction(FAILURE),
  }
}

export function createPostAction<T>(type: string): IPostActionGroup {
  const POST = `${type}/POST`
  const SUCCESS = `${type}/SUCCESS`
  const FAILURE = `${type}/FAILURE`
  const REQUEST = `${type}/REQUEST`

  return {
    TYPE: type,
    POST,
    SUCCESS,
    FAILURE,
    REQUEST,
    post: createAction<T>(POST),
    request: createAction(REQUEST),
    success: createAction(SUCCESS),
    failure: createAction(FAILURE),
  }
}

export function createSaga<P>(actions: IFetchActionGroup | IPostActionGroup, req: any) {
  return function*(action: Action<P>) {
    const payload = oc(action).payload()

    yield put(loadingActions.start(actions.TYPE))
    try {
      yield put(actions.request(payload))
      const res = yield call(req, payload)
      yield put(actions.success(res))
    } catch (e) {
      yield put(actions.failure(e))
      yield put(errorActions.set(e))
    } finally {
      yield put(loadingActions.finish(actions.TYPE))
    }
  }
}
